import PropTypes from 'prop-types';
// import { ActionIcon, Tooltip, useMantineColorScheme } from '@mantine/core';
// import { IconMoon, IconSun } from '@tabler/icons-react';
// import { useTranslation } from 'react-i18next';
import LayoutWrapper from '@/components/LayoutWrapper';
import classes from './header.module.css';
import Logo from '@/assets/images/logo.svg?react'; // eslint-disable-line import/no-unresolved

// TODO: remove not needed core remarks

const Header = (props) => {
  const {
    showLogo = true,
  } = props;

  // const { t } = useTranslation();

  // const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  // const tooltipLabel = (colorScheme === 'dark')
  //   ? t('layout.default.action.dark.label')
  //   : t('layout.default.action.light.label');

  // const icon = (colorScheme === 'dark') ? <IconSun /> : <IconMoon />;

  return (
    <div className={classes.header}>
      <LayoutWrapper>
        <div className={classes.headerContent}>
          {showLogo && <div className={classes.logo}><Logo /></div>}
          <div className={classes.actions}>
            {/* <Tooltip label={tooltipLabel}>
              <ActionIcon variant="default" onClick={toggleColorScheme}>
                {icon}
              </ActionIcon>
            </Tooltip> */}
          </div>
        </div>
      </LayoutWrapper>
    </div>
  );
};

Header.propTypes = {
  showLogo: PropTypes.bool,
};

export default Header;
